const config={
    x:1,
    y:2,
    z:0
    
}
const rotate={
    x:90,
    y:0,
    z:90
}
const zif=false
// 切面配置
const items = [
    {
        label: 'Coronal sections',
        key: 'Coronal sections',
    },
    {
        label: 'Sagittal sections',
        key: 'Sagittal sections',
    },
    {
        label: 'Horizontal sections',
        key: 'Horizontal sections',
    },
];
// 树结构配置
const menu=[
    {
        label: 'nucleusColour',
        key: 'nucleusColour.json'
      },
      {
        label: 'nucleusColour_swanson',
        key: 'nucleusColour_swanson.json'
      }
]
// 数据参数
const ZifData={
    Width:35077, 
    Height:27693,
    voxelResolution: 1,
    Coronal: {
        count: 700,
        zif_start:'00001',
        zif_end:'00700'
    },
    Sagittal: {
        count: 256,
        zif_start:'05721',
        zif_end:'10821'
    },
    Horizontal: {
        count: 367,
        zif_start:'00681',
        zif_end:'08001'
    }
}
export { config, rotate,zif,items,menu,ZifData };